import { createFileRoute } from '@tanstack/react-router';

import { ensureMediaQueryData } from '@/api/media';
import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';

export const Route = createFileRoute(
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new'
)({
  loader: ensureMediaQueryData,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="360Virtual-tours" /> },
});
